import * as React from 'react';

import {appHistory} from '../../../../../history';

import {PageTabs} from '../tabs/page-tabs/page-tabs';

import type {TabProps as Tabs, Variant} from './page-control-bar';

type Props = {
    tabs: Tabs;
    shouldOnlyShowActiveTab?: boolean;
    lessPadding?: boolean;
    variant?: Variant;
};

export function PageControlBarTabs(props: Props) {
    return (
        <PageTabs
            tabs={props.tabs.options
                .filter((tab) => !tab.isHidden)
                .map((tab) => {
                    const isActive = props.tabs.selectedTab === tab.id;

                    let label = null;
                    if (
                        !props.shouldOnlyShowActiveTab ||
                        (props.shouldOnlyShowActiveTab && isActive)
                    ) {
                        label = tab.label;
                    }

                    const onClick = () => {
                        if (tab.onClick) {
                            tab.onClick();
                        }

                        if (props.tabs.onChangeTab) {
                            props.tabs.onChangeTab(tab.id);
                        } else if (tab.href) {
                            appHistory.push(tab.href);
                        }
                    };

                    return {
                        id: tab.id,
                        label,
                        Icon: tab.icon,
                        isActive,
                        onClick,
                        count: tab.count,
                        badgeColor: tab.badgeColor,
                    };
                })}
            currentView={props.tabs.selectedTab}
            // @ts-expect-error
            onChange={props.tabs.onChangeTab}
            lessPadding={props.lessPadding}
            variant={props.variant}
        />
    );
}
